<template>
  <div class="section-main__warp inspection-wrap">
    <ioc-table ref="crud"
               v-model="plan"
               :data="tableData"
               :option="option"
               :page="page"
               @row-save="handleCreate"
               @row-update="handleUpdate"
               @row-cancle="closeDialog"
               @search-change="handleSearchChange"
               @search-reset="handleSearchReset"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange">
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button v-auth="'/assetinspection/inspectionPlan:add'"
                   type="primary"
                   size="small"
                   class="iss-operation-button"
                   icon="el-icon-plus"
                   @click="handleAddAccount">
          {{ $t('workGroup.button.add') }}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip class="item"
                    effect="dark"
                    content="详情"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="iconfont icon-Detail"
                     @click="handleView(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button v-auth="'/assetinspection/inspectionPlan:delete'"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDel(scope.row)"></el-button>
        </el-tooltip>
      </template>
      <!-- 表格列 状态 -->
      <template slot="status"
                slot-scope="scope">
        <el-switch v-auth="'/assetinspection/inspectionPlan:active'"
                   v-model="scope.row.status"
                   active-value="1"
                   inactive-value="2"
                   @change="handleUpdateStatus(scope.row)"></el-switch>
        {{ scope.row.$status }}
      </template>
      <!-- 新增/修改表单 自定义 -->
      <!-- 巡检范围 -->
      <template slot="areaListForm"
                slot-scope="scope">
        <div style="flex:1;position:relative">
          <el-input placeholder="请选择"
                    ref="area-input"
                    @click.native="areaTreeShow"
                    class="bukongObject"
                    :readonly="true"
                    v-model="plan.areaList"
                    @blur="areaSlotChange(scope.row)"></el-input>
          <div v-if="addGroupList"
               style="position:absolute;bottom:-205px;width:100%;z-index:999999;height:200px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);">
            <div style="position:relative;height:80%;">
              <app-camers-group type="2"
                                ref="areaTree"
                                url="/cms/area/queryAreaByAccountName.json"
                                :isRequired="true"
                                @changeCamersGroup="changeCamersGroup"
                                style="width:100%;height:100%;position;inherit;right:-10px;top:0">
              </app-camers-group>
            </div>
            <div style="text-align: center">
              <el-button type="primary"
                         @click="confirmCamers('add')">{{ $t('taskCenter.button.conform') }}</el-button>
              <el-button type="info"
                         @click="cancelCamers('add')">{{ $t('taskCenter.button.cancel') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 巡检人员 -->
      <template slot="inspectPersonListForm">
        <div style="flex:1;position:relative">
          <el-input placeholder="请选择"
                    ref="person-input"
                    @click.native="personShow"
                    class="bukongObject"
                    :readonly="true"
                    v-model="plan.areaList"
                    v-show="false"
                    @blur="personSlotChange(scope.row)"></el-input>
          <div>
            <div style="position:relative;height:80%;">
              <work-group-tree ref="workGroupTree"
                               :multiCheck="true"
                               @groupData="getGroupData"
                               :showPercentage="false"></work-group-tree>
              <!-- <app-camers-group type="2"
                                ref="areaTree"
                                url="/cms/area/queryAreaByAccountName.json"
                                :isRequired="true"
                                @changeCamersGroup="changeCamersGroup"
                                style="width:100%;height:100%;position;inherit;right:-10px;top:0">
              </app-camers-group> -->
            </div>
          </div>
        </div>
      </template>
      <template slot="fireassetDevForm">
        <!-- <span class="valid">*</span> -->
        <div class="add_rec">
          <el-button icon="el-icon-plus"
                     type="primary"
                     size="small"
                     @click="addShow = true">添加</el-button>
          <div class="add_rec_content"
               v-if="addShow">
            <div class="add_rec_select">
              <div>
                <label for="">资产类型：</label>
                <el-select v-model="fireassetType"
                           placeholder="请选择"
                           style="width:150px"
                           @change="fireassetTypeChange">
                  <el-option v-for="item in assetsTypeOption"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"> </el-option>
                </el-select>
              </div>
              <div>
                <label for="">巡检项目：</label>
                <el-select v-model="patrolItemList"
                           multiple
                           collapse-tags
                           placeholder="请选择"
                           style="width:150px">
                  <el-option v-for="item in fireassetNameOption"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"> </el-option>
                </el-select>
              </div>
            </div>
            <div class="add_rec_btn">
              <el-button type="primary"
                         @click="submitAddAssets">确定</el-button>
              <el-button type="info"
                         @click="addShow = false">取消</el-button>
            </div>
          </div>
        </div>
        <ioc-table ref="addRecipient"
                   :data="addTableData"
                   :option="addOption"
                   :page="{}"> </ioc-table>
      </template>
    </ioc-table>
    <inspection-detail ref="detail"></inspection-detail>
  </div>
</template>
<script>
import { api } from '../api'
import addOption from '../const/addOption'
import tableOption from '../const/patrolOption'
import appCamersGroup from '@components/app-camera-group'
import inspectionDetail from '../components/inspectionDetail'
import utils from '@src/common/utils'
import { Dic, Bus, Dates } from '$utils'
import workGroupTree from "@src/modules/realTimeAlarm/components/workGroupTree";

export default {
  components: {
    appCamersGroup,
    inspectionDetail,
    workGroupTree
  },
  data () {
    return {
      plan: {
        areaList: '',
        inspectPersonList: ''
      },
      tableData: [],
      checkedAssets: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      searchParams: {},
      option: tableOption(this),
      addOption: addOption(),
      rowInfo: {},
      addGroupList: false,
      // areaName: '',
      fireassetType: '',
      patrolItemList: [],
      form: {
        areaList: [
          // {
          //   area: '',//区域编号
          //   areaName: '', //区域名称
          // }
        ],
        fireassetTypeList: [
          // {
          //   fireassetType: '',
          //   patrolItemList: []
          // }
        ],
        inspectPersonList: [],
        creator: '',
        startTime: '',
        endTime: '',
      },
      addShow: false,
      addTableData: [],
      assetsType: Dic.find('SENU077'),
      assetsTypeOption: Dic.find('SENU077'),
      assetsTypeExist: [],
      assetsTypeExistOption: [],
      // fireassetNameOption: Dic.find('SENU078'),
      fireassetNameOption: [],
      workGroup: [],
      personListShow: false,
      inspectPersonNameList: []
    }
  },
  mounted () {
    this.getList()
    this.queryWorkGroup()
    console.log('userInfo', this.userInfo)
  },
  created () { },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  methods: {
    handleSearchReset () {
      this.getList()
    },
    getList () {
      const params = {
        planName: this.searchParams.planName, //'巡检计划名称'
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      }
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(api.inspectionPlan.queryInspectionPlan, params).then((response) => {
        setTimeout(() => {
          loading.close()
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent)
          return
        } else {
          this.tableData = response.returnObj ? Object.freeze([...response.returnObj.list]) : []
          this.page.total = response.returnObj ? response.returnObj.total : 0
          this.$refs.crud.selectClear()
        }
      })
    },
    // 查询巡检项
    // fireassetTypeChange (val) {
    //   const params = {
    //     categoryId: '1',
    //     cfgCode: `ASSET_TYPE_${val}_PATROL_ITEMS`,
    //     cfgDesc: '',
    //     pageNum: 1,
    //     pageSize: 10
    //   }
    //   this.$fetch(api.inspectionPlan.querySysConfigList, params).then((res) => {
    //     if (!res.success) {
    //       this.$message.error(res.msgContent)
    //       return
    //     } else if (res.returnObj.list) {
    //       this.fireassetNameOption = res.returnObj.list.map(item => {
    //         return { value: item.cfgValueType, label: item.cfgValue }
    //       })
    //     }
    //   })
    // },
    fireassetTypeChange (val) {
      this.patrolItemList = []
      const params = {
        fireassetType: val,
        pageNum: 1,
        pageSize: 10
      }
      this.$fetch(api.inspectionPlan.queryPatrolItemConfig, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent)
          return
        } else if (res.returnObj.list) {
          this.fireassetNameOption = res.returnObj.list.map(item => {
            return { value: item.patrolItem, label: item.patrolItem }
          })
        }
      })
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList()
    },
    handleSearchChange (param) {
      this.searchParams = param
      this.page.currentPage = 1
      this.getList()
    },
    handleAddAccount () {
      this.$refs.crud.rowAdd()
    },
    handleView (row) {
      this.$refs.detail.open(row)
    },
    handleEdit (row, index) {
      this.rowInfo = row
      this.$refs.crud.rowEdit(row, index)
    },
    handleDel (row) {
      const params = {
        planCode: row.planCode, //'巡检计划code'
      }
      this.$confirm('您确定删除该巡检计划吗?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$fetch(api.inspectionPlan.deleteInspectionPlan, params).then((response) => {
          if (response && response.success) {
            this.$message.success(response.msgContent)
            this.getList()
          } else {
            this.$message.error(response.msgContent)
          }
        })
      })
    },
    // 新建巡检任务
    handleCreate (addInfo, done) {
      this.form.creator = this.userInfo.account
      this.form.startTime = Dates.format(addInfo.startTime, 'yyyy-MM-dd')
      this.form.endTime = Dates.format(addInfo.endTime, 'yyyy-MM-dd')
      if (Date.parse(this.form.startTime) > Date.parse(this.form.endTime)) {
        this.$message.warning('计划开始时间不能大于计划结束时间')
        return
      }

      this.$refs['crud'].$refs['form'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          const param = Object.assign(addInfo, this.form)
          this.$fetch(api.inspectionPlan.addInspectionPlan, param).then((res) => {
            if (res && res.success) {
              this.getList()
              this.assetsTypeOption = this.assetsType
              this.$message.success(res.msgContent)
              this.form = {
                areaList: [],
                fireassetTypeList: [],
                inspectPersonList: [],
                creator: '',
                startTime: '',
                endTime: '',
              }
              done()
            } else {
              this.$message.error(res.msgContent)
            }
          })
        }
      })
    },
    // 修改消防资产
    handleUpdate (updateInfo, done) {
      this.$fetch(api.assetsManage.updateAssetsInfo, updateInfo).then((res) => {
        if (res.success) {
          this.$message.success(res.msgContent)
          this.getList()
        } else {
          this.$message.error(res.msgContent)
        }
        done()
      })
    },
    handleUpdateStatus (row) {
      this.$confirm(`确定要${row.status == '1' ? '启动' : '禁止'}此任务吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            planCode: row.planCode, //'巡检计划code'
            status: row.status.toString(), //状态 1：启动,2：禁止
          }
          this.$fetch(api.inspectionPlan.startOrStopPlan, params).then((res) => {
            if (res.success) {
              this.$message({
                showClose: false,
                message: `巡检任务${row.status === '1' ? '启动' : '禁止'}成功`,
                type: 'success',
                duration: 2000,
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '取消成功！',
            duration: 2000,
          })
        })
    },
    areaTreeShow () {
      this.addGroupList = true
    },
    personShow () {
      this.personListShow = true
    },
    getGroupData (data) {
      this.inspectPersonNameList = []
      this.form.inspectPersonList = data.map(item => {
        this.inspectPersonNameList.push(item.name)
        return {
          accountNumber: item.id, //账号
          nickName: item.name, //姓名
        }
      });
      this.$set(this.plan, 'inspectPersonList', this.inspectPersonNameList.toString())
      this.$refs['person-input'].focus()
    },
    changeCamersGroup (data, type) {
      this.form.areaList = []
      const areaListName = []
      data.map((val) => {
        areaListName.push(val.areaDevGroupName)
        this.form.areaList.push({
          areaName: val.areaDevGroupName,
          area: val.areaDevGroupCode,
        })
      })
      this.$set(this.plan, 'areaList', areaListName.toString())
      this.$refs['area-input'].focus()
      // this.plan.areaList = areaListName.toString()
    },
    areaSlotChange (row) {
      this.$set(row, 'areaList', this.plan.areaList)
      // row.areaList = this.plan.areaList;
      console.log(row)
    },
    personSlotChange () {
      this.$set(row, 'inspectPersonList', this.form.inspectPersonList)
    },
    confirmCamers (param) {
      if (param === 'search') {
        this.groupList = false
      } else {
        this.addGroupList = false
      }
    },
    cancelCamers (param) {
      if (param === 'search') {
        this.groupList = false
      } else {
        this.addGroupList = false
      }
    },
    closeDialog () {
      this.assetsTypeOption = this.assetsType
      this.addTableData = []
      this.addGroupList = false
    },
    // 确认新增一条巡检
    submitAddAssets () {
      //过滤已选项
      this.assetsTypeOption = this.assetsTypeOption.filter((item) => {
        return item.value !== this.fireassetType
      })
      const patrolItemNameList = []
      let patrolItemObjList = []
      if (!(this.fireassetType && this.patrolItemList)) {
        this.$message.warning('请选择巡检内容')
        return false
      }
      patrolItemObjList = this.fireassetNameOption.map((item) => {

        if (this.patrolItemList.indexOf(item.value) !== -1) {
          return item.label
        }
      })
      // patrolItemObjList.push({
      //   patrolItem: this.fireassetNameOption[0].label
      // })
      console.log('patrolItemObjList', this.patrolItemObjList)
      this.addTableData.push({
        fireassetType: Dic.findByValue('SENU077', this.fireassetType),
        patrolItem: patrolItemObjList.toString(),
      })
      this.form.fireassetTypeList.push({
        fireassetType: this.fireassetType.toString(),
        patrolItemList: this.patrolItemList,
      })
      this.fireassetType = ''
      this.patrolItemList = []
      this.fireassetName = []
    },
    // 资产巡检人员查询
    queryWorkGroup () {
      const params = {
        areaCode: [],
        parkId: '200000001',
        type: '4'
      }
      this.$fetch(api.inspectionPlan.queryWorkGroupByAreaOrDevice, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent)
          return
        } else {
          this.workGroup = res.returnObj[0].accounts.map((item) => {
            return {
              label: item.nickName,
              value: item.accountNumber,
            }
          })
          this.option.column[5].dicData = this.workGroup
        }
      })
    },
  },
}
</script>
<style lang="scss">
@import "../style/inspectionPlan.scss";
</style>
